import * as React from "react"

const IconFloorPlan = ({ height, width, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={height ?? 24} width={width ?? 24}>
    <path fill="none" d="M0 0h24v24H0z" data-name="Rectangle 2241" />
    <path
      fill={color ?? "currentColor"}
      stroke={color ?? "currentColor"}
      strokeWidth={0.3}
      d="M4 4h6v1H4z"
      data-name="Rectangle 1789"
    />
    <path
      fill={color ?? "currentColor"}
      stroke={color ?? "currentColor"}
      strokeWidth={0.3}
      d="M14 4h6v1h-6z"
      data-name="Rectangle 1790"
    />
    <g
      fill={color ?? "currentColor"}
      stroke={color ?? "currentColor"}
      strokeWidth={0.3}
      data-name="Group 11805"
    >
      <path d="M4 4h1v16H4z" data-name="Rectangle 1786" />
      <path d="M4 19h16v1H4z" data-name="Rectangle 1787" />
      <path d="M8 12h5v1H8z" data-name="Rectangle 1791" />
      <path d="M16 12h4v1h-4z" data-name="Rectangle 1793" />
      <path d="M19 4h1v16h-1z" data-name="Rectangle 1788" />
      <path d="M10 12h1v8h-1z" data-name="Rectangle 1792" />
    </g>
  </svg>
)
export default IconFloorPlan
